/**
 * Enum for SharedModal operation modes
 */
export const MODAL_MODE = Object.freeze({
  NORMAL: 0,        // Show message with OK and Cancel buttons
  MATCH_TEXT: 1,    // Require exact text matching to enable OK button
  REQUIRE_INPUT: 2  // Require any text/password input to enable OK button
});
